import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import Close from "shared/components/utils/icons/Close";
import { CloseWrapper, MagnifierWrapper, TextField, Wrapper } from "./IconTextInput.styles";

const TextInput = (props) => {
    const { type, defaultValue, icon, onChange } = props;

    const [value, setValue] = useState(defaultValue);

    const searchInput = useRef();

    const handleCancelSearch = () => {
        setValue("");
        onChange("");
        searchInput.current.focus();
    };

    function handleChange(e) {
        setValue(e.target.value);
        onChange(e.target.value);
    }

    useEffect(() => {
        searchInput.current.focus();
    }, []);

    return (
        <Wrapper>
            <MagnifierWrapper>{icon}</MagnifierWrapper>
            <TextField
                type={type}
                value={value}
                onChange={handleChange}
                placeholder="Employee Name"
                ref={searchInput}
            />

            <CloseWrapper onClick={() => handleCancelSearch()}>
                <Close size="9"></Close>
            </CloseWrapper>
        </Wrapper>
    );
};

TextInput.defaultProps = {
    defaultValue: "",
};

TextInput.propTypes = {
    type: PropTypes.string,
    defaultValue: PropTypes.string,
    icon: PropTypes.node,
    onChange: PropTypes.func,
};

export default TextInput;
